// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"2d1673fc","183":"5109c2ed","264":"002058b9","345":"c8b53e7d","675":"0a8d2666","719":"8768b7e1","797":"f430098e"}[chunkId] + ".chunk.css";
};